module.exports = __webpack_public_path__ + "front/img/login_bg.0d892ec5.png";